/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { NodeCompat } from '../../../../compat/NodeCompat';
import { Constants } from '../../../Constants';
import { IDefinition } from '../../../models/common/IDefinition';
import { Parameter } from '../../../models/common/Parameter';
import { ValidationRuleMetaData } from '../../ValidationRuleMetaData';
import { OasParameter } from '../../../../openapi/models/OasParameter';
import { RequiredPropertyValidationRule } from './RequiredPropertyValidationRule';

/**
 * Constructor.
 * @param {ValidationRuleMetaData} ruleInfo
 * @class
 * @extends RequiredPropertyValidationRule
 * @author eric.wittmann@gmail.com
 */
export class OasPathParamsMustBeRequiredRule extends RequiredPropertyValidationRule {
    public constructor(ruleInfo : ValidationRuleMetaData) {
        super(ruleInfo);
    }

    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitParameter(io.apicurio.datamodels.core.models.common.Parameter)
     * @param {Parameter} node
     */
    public visitParameter(node : Parameter) {
        let $ref : string = <string>NodeCompat.getProperty(node, Constants.PROP_$REF);
        if(this.hasValue($ref)) {
            return;
        }
        let param : OasParameter = <OasParameter>node;
        if(this.equals(param.in, "path") && !this.equals(param.required, true)) {
            this.report(node, Constants.PROP_REQUIRED, this.map("name", node.name));
        }
    }

    /**
     * @see io.apicurio.datamodels.combined.visitors.CombinedAllNodeVisitor#visitParameterDefinition(io.apicurio.datamodels.core.models.common.IDefinition)
     * @param {*} node
     */
    public visitParameterDefinition(node : IDefinition) {
        this.visitParameter(<Parameter><any>node);
    }
}
OasPathParamsMustBeRequiredRule["__class"] = "io.apicurio.datamodels.core.validation.rules.required.OasPathParamsMustBeRequiredRule";
OasPathParamsMustBeRequiredRule["__interfaces"] = ["io.apicurio.datamodels.core.visitors.IVisitor","io.apicurio.datamodels.asyncapi.v2.visitors.IAai20Visitor","io.apicurio.datamodels.openapi.v3.visitors.IOas30Visitor","io.apicurio.datamodels.asyncapi.visitors.IAaiVisitor","io.apicurio.datamodels.openapi.v2.visitors.IOas20Visitor","io.apicurio.datamodels.openapi.visitors.IOasVisitor"];




